import React from 'react';

interface ColoredDotProps {
  color?: string;
  className?: string;
  size?: number;
}

const ColoredDot: React.FC<ColoredDotProps> = ({ color = 'bg-blue-500', className, size = 8 }) => {
  return (
    <div
      className={`rounded-full ${className}`}
      style={{
        backgroundColor: color,
        width: size + 'px',
        height: size + 'px'
      }}
    />
  );
};

export default ColoredDot;
